import script from "./BaseClientDetailsTab.vue?vue&type=script&lang=js"
export * from "./BaseClientDetailsTab.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__